<template>
  <div class="wrapper" role="site">
    <headerBar :authenticated="true"></headerBar>
    <div class="container">
      <div class="grid__sidebar">
        <p4a-brandbar :showNotificationButton="true" :showSidebarButton="true" :product="'ds'"></p4a-brandbar>
        <div class="grid__sidebar-content"
             v-resize="{orientation: 'vertical'}"
             v-show="sidebarVisible">
          <iframe src="/treeview" frameborder="0" style="width: calc(100% - 53px); height: calc(100vh - 308px);"></iframe>
          <mainNav></mainNav>
        </div>
      </div>
      <div class="grid__content">
        <div class="grid__toolbar">
          <toolBar></toolBar>
        </div>
        <div class="grid__center">
          <div class="grid__center-content">
            <div class="grid__document"
                 v-resize="{orientation: 'horizontal'}">
              <div class="row">
                <!-- <grid></grid> -->
              </div>
            </div>
            <div class="grid__version">
              <div class="row">
                <div class="table">
                  <div class="table__top"></div>
                  <table style="width: 100%;" :class="{'compact' : !compact}">
                    <thead class="table__head">
                    <tr>
                      <th class="table__select" style="width: 30px; max-width: 30px; min-width: 30px;">
                        <p4a-checkbox
                          :disabled="false"
                          :selected="false"
                          :textHidden="true">
                        </p4a-checkbox>
                      </th>
                      <th class="table__image" style="width: 52px; max-width: 52px; min-width: 52px;"></th>
                      <th v-for="head in table.header" :key="head.position">
                        <div class="title">
                          <span class="title__text">{{ head.name }}</span>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="table__body">
                    <tr :class="body.selected ? 'selected' : ''" v-for="(body, i) in table.body" :key="i">
                      <td style="width: 30px;">
                        <p4a-checkbox
                          :disabled="false"
                          :textHidden="true"
                          :checked="body.active">
                        </p4a-checkbox>
                      </td>
                      <td class="table__image" style="width: 40px; max-width: 40px; min-width: 40px;">
                        <img :src="require('../assets/img/grid/' + body.image + '.png')" :alt="body.image"/>
                      </td>
                      <td v-for="(content, i) in body.value" :key="i" :data-position="content.position"><span class="text">{{ content.text }}</span></td>
                      <div class="fake"></div>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__property">
            <tabs :vertical="true">
              <tab name="Eigenschappen" icon="dashboard" :selected="true">
                <h2 class="grid__title">Eigenschappen</h2>
                <div class="grid__property__content">
                  <ul class="grid__list">
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Bestandstype
                      </div>
                      <div class="grid__list__content">
                        docx
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Docstream nummer
                      </div>
                      <div class="grid__list__content">
                        0018192
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Gemaakt op
                      </div>
                      <div class="grid__list__content">
                        24-05-2019 11:10:26
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Gepubliceerd op
                      </div>
                      <div class="grid__list__content">
                        24-05-2019 11:10:26
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Gepubliceerd door
                      </div>
                      <div class="grid__list__content">
                        Rick van den Berg
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Afgekeurd op
                      </div>
                      <div class="grid__list__content">
                        24-05-2019 11:10:26
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Afgekeurd door
                      </div>
                      <div class="grid__list__content">
                        Rick van den Berg
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        Bestandsgrootte
                      </div>
                      <div class="grid__list__content">
                        16 Kb
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__list__content">
                        MD5 checksom
                      </div>
                      <div class="grid__list__content">
                        67890okmjnbv
                      </div>
                    </li>
                  </ul>
                </div>
              </tab>
              <tab name="Commentaren" icon="sns-project">
                <h2 class="grid__title">Commentaren</h2>
                <div class="grid__property__content">
                  <ul class="grid__list">
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            Commentaar op zoekfunctie
                          </p>
                          <p class="grid__comment__title--sub">
                            Rick van den Berg op 29-06-2019 17:33
                          </p>
                          <p class="grid__comment__text">
                            Met de nieuwe zoek/filter functie is het mogelijk om nog sneller de documenten terug te vinden. In iedere map kunt u zoeken op een willekeurig...
                          </p>
                          <p4a-button class="grid__comment__transparent__button" :text="'openen'"></p4a-button>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            Algemeen commentaar
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 14-05-2019 13:23
                          </p>
                          <p class="grid__comment__text">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volut...
                          </p>
                          <p4a-button class="grid__comment__transparent__button" :text="'openen'"></p4a-button>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            Reactie op Louis Litt
                          </p>
                          <p class="grid__comment__title--sub">
                            Arno Wibo op 14-05-2019 13:23
                          </p>
                          <p class="grid__comment__text">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                          </p>
                          <p4a-button class="grid__comment__transparent__button" :text="'openen'"></p4a-button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </tab>
              <tab name="Berichten" icon="user">
                <h2 class="grid__title">Berichten</h2>
                <div class="grid__property__content">
                  <ul class="grid__list">
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            4953 - Berichtonderwerp
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 29-06-2019 17:33
                          </p>
                          <ul class="grid__list">
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Versie
                              </div>
                              <div class="grid__list__content">
                                1
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Gereageerd
                              </div>
                              <div class="grid__list__content">
                                07-08-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Uiterste datum
                              </div>
                              <div class="grid__list__content">
                                21-08-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Ontvanger
                              </div>
                              <div class="grid__list__content">
                                rvandenberg@pro4all.nl
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            4934 - Aanpassen van bestand
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 29-06-2019 17:33
                          </p>
                          <ul class="grid__list">
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Versie
                              </div>
                              <div class="grid__list__content">
                                1
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Gereageerd
                              </div>
                              <div class="grid__list__content">
                                01-04-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Uiterste datum
                              </div>
                              <div class="grid__list__content">
                                15-10-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Ontvanger
                              </div>
                              <div class="grid__list__content">
                                rvandenberg@pro4all.nl
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            4934 - Aanpassen van bestand
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 29-06-2019 17:33
                          </p>
                          <ul class="grid__list">
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Versie
                              </div>
                              <div class="grid__list__content">
                                1
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Gereageerd
                              </div>
                              <div class="grid__list__content">
                                01-04-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Uiterste datum
                              </div>
                              <div class="grid__list__content">
                                15-10-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Ontvanger
                              </div>
                              <div class="grid__list__content">
                                rvandenberg@pro4all.nl
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            4934 - Aanpassen van bestand
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 29-06-2019 17:33
                          </p>
                          <ul class="grid__list">
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Versie
                              </div>
                              <div class="grid__list__content">
                                1
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Gereageerd
                              </div>
                              <div class="grid__list__content">
                                01-04-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Uiterste datum
                              </div>
                              <div class="grid__list__content">
                                15-10-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Ontvanger
                              </div>
                              <div class="grid__list__content">
                                rvandenberg@pro4all.nl
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="grid__list__item">
                      <div class="grid__comment">
                        <div class="grid__comment__picture">
                          <img :src="require('img/profile.jpg')" />
                        </div>
                        <div class="grid__comment__content">
                          <p class="grid__comment__title">
                            4934 - Aanpassen van bestand
                          </p>
                          <p class="grid__comment__title--sub">
                            Louis Litt op 29-06-2019 17:33
                          </p>
                          <ul class="grid__list">
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Versie
                              </div>
                              <div class="grid__list__content">
                                1
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Gereageerd
                              </div>
                              <div class="grid__list__content">
                                01-04-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Uiterste datum
                              </div>
                              <div class="grid__list__content">
                                15-10-2019
                              </div>
                            </li>
                            <li class="grid__list__item">
                              <div class="grid__list__content">
                                Ontvanger
                              </div>
                              <div class="grid__list__content">
                                rvandenberg@pro4all.nl
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </tab>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBar from './header/header'
import toolBar from './toolBar/toolBar'
import treeView from './treeView/treeView'
import mainNav from './mainNav/mainNav'
import Tab from './tab/tab'
import Tabs from './tab/tabs'

export default {
  name: 'Secure',
  components: {
    'headerBar': headerBar,
    'toolBar': toolBar,
    'treeView': treeView,
    'mainNav': mainNav,
    'tab': Tab,
    'tabs': Tabs
  },
  data () {
    return {
      sidebarVisible: true,
      table: {
        header: [
          {
            name: 'Bedrijf'
          },
          {
            name: 'Documentnaam'
          },
          {
            name: 'Categorie'
          },
          {
            name: 'Soort'
          },
          {
            name: 'Status'
          },
          {
            name: 'Versie'
          },
          {
            name: 'Door'
          },
          {
            name: 'Datum'
          },
          {
            name: 'Tijd'
          }
        ],
        body: [
          {
            id: 1,
            active: false,
            image: 'ps',
            selected: false,
            value: [
              {
                text: 'Pro4all',
                position: 1
              },
              {
                text: 'FS934',
                position: 2
              },
              {
                text: 'Plattegrond',
                position: 3
              },
              {
                text: 'Intern Project',
                position: 4
              },
              {
                text: 'C',
                position: 5
              },
              {
                text: 'UX design',
                position: 6
              },
              {
                text: 'UX_designer_3',
                position: 7
              },
              {
                text: 'Dit is een lange tekst in deze tabel',
                position: 8
              }
            ]
          },
          {
            id: 2,
            active: false,
            image: 'ps',
            selected: false,
            value: [
              {
                text: 'Pro4all',
                position: 1
              },
              {
                text: 'FS934',
                position: 2
              },
              {
                text: 'Plattegrond',
                position: 3
              },
              {
                text: 'Intern Project',
                position: 4
              },
              {
                text: 'C',
                position: 5
              },
              {
                text: 'UX design',
                position: 6
              },
              {
                text: 'UX_designer_3',
                position: 7
              },
              {
                text: 'Dit is een lange tekst in deze tabel',
                position: 8
              }
            ]
          },
          {
            id: 3,
            active: false,
            image: 'ps',
            selected: false,
            value: [
              {
                text: 'Pro4all',
                position: 1
              },
              {
                text: 'FS934',
                position: 2
              },
              {
                text: 'Plattegrond',
                position: 3
              },
              {
                text: 'Intern Project',
                position: 4
              },
              {
                text: 'C',
                position: 5
              },
              {
                text: 'UX design',
                position: 6
              },
              {
                text: 'UX_designer_3',
                position: 7
              },
              {
                text: 'Dit is een lange tekst in deze tabel',
                position: 8
              }
            ]
          }
        ]
      },
      compact: localStorage.getItem('compact') === 'false'
    }
  },
  methods: {
    test () {
      console.log('1')
    }
  },
  created () {
    if (localStorage.getItem('authenticated') === null || localStorage.getItem('authenticated') === 'false') {
      this.$router.push({ name: '/' })
    }
    this.$eventBus.$on('sidebarVisible', value => {
      this.sidebarVisible = value
    })
    this.$eventBus.$on('compact', value => {
      this.compact = value
    })
    this.compact = localStorage.getItem('compact') === 'true'
    if (localStorage.getItem('compact') === null) {
      this.compact = true
      localStorage.setItem('compact', true)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/authenticated.vue